// STDominicana Data - Extracted from Original HTML Design
// This file contains the EXACT content from the original HTML file

const data = {
  // Brand Information
  logo: "/assets/stdominicana/images/logo.png",
  title: "Soluciones Térmicas Dominicana",
  tagline: "Soluciones en aislamiento térmico para la industria",

  // Navigation Menu (from original HTML)
  navigation: [
    {
      label: "¿Quiénes Somos?",
      url: "/quienes-somos",
      slug: "about"
    },
    {
      label: "Trabajos realizados",
      url: "/trabajos-realizados",
      slug: "projects"
    },
    {
      label: "Contactenos",
      url: "/contactenos",
      slug: "contact"
    }
  ],

  about: {
    title: "¿Quiénes Somos?",
    subtitle: "Nuestros Servicios",
    description: "En Soluciones Térmicas Dominicana nos enfocamos en brindar las alternativas más confiables que llevan a mantener los equipos industriales, eficientizando su productividad al menor costo energético, dependiendo de la cultura empresarial.",
    image: "/assets/stdominicana/images/about-image.jpg",
    cta: {
      text: "Más información",
      url: "/quienes-somos"
    }
  },

  // Mission, Vision and Values
  missionVisionValues: {
    sectionId: "mission-vision-values",
    title: "Nuestra Filosofía",
    subtitle: "Los pilares que guían nuestro trabajo",
    items: [
      {
        type: "Misión",
        title: "MISIÓN",
        description: "Proveer servicios de aislamiento térmico en los cuales nuestros clientes visualizan a través de la mejor orientación, el ahorro de energía. Esta es la contribución fundamental para la Conservación del Planeta.",
        icon: "faTarget",
        color: "#1e40af"
      },
      {
        type: "Visión",
        title: "VISIÓN",
        description: "Ser líderes profesionales en el área de aislamiento térmico con capacidad creativa para llenar todas las expectativas y necesidades de cada cliente.",
        icon: "faEye",
        color: "#f0854d"
      },
      {
        type: "Valores",
        title: "VALORES",
        description: "Cumplimiento, lealtad, honestidad, respeto, comunicación, puntualidad como un conjunto de factores dirigidos a cumplir metas en el área de aislamiento térmico que llenen las expectativas de nuestros clientes.",
        icon: "faHeart",
        color: "#28a745"
      }
    ]
  },

  // Hero Section (from original HTML)
  hero: {
    title: "Soluciones en aislamiento térmico para la industria",
    legend: "Proveemos asesoría sin costo alguno, para solucionar todas las necesidades que presenta la Industria en el área de Aislamiento Térmico.",
    subtitle: "HONESTIDAD, CUMPLIMIENTO Y PUNTUALIDAD ES LO QUE NOS CARACTERIZA.",
    backgroundImage: "/assets/stdominicana/images/soluciones-termicas-dominicana-aislamiento.jpg",
    cta: {
      text: "Contáctenos",
      url: "/contactenos"
    }
  },

  // Our Services Section (from stdom.html - id="our-services")
  // Two-column layout: text left, image right
  ourServices: {
    sectionId: "our-services",
    title: "Nuestros Servicios",
    content: "En Soluciones Térmicas Dominicana nos enfocamos en brindar las alternativas más confiables que llevan a mantener los equipos industriales eficientizando su productividad al menor costo energético dependiendo de la cultura empresarial al mismo tiempo que la seguridad misma.",
    image: "/assets/stdominicana/images/pexels-photo-257736-1024x682.jpeg",
    cta: {
      text: "Más información",
      url: "/quienes-somos"
    },
    layout: "image-right"
  },

  // Services
  services: [
    {
      title: "Protección para equipos de baja temperatura",
      slug: "aislamiento-termico",
      description: "Soluciones profesionales para protección de equipos que trabajan en bajas temperaturas.",
      image: "/assets/stdominicana/images/aislamiento.jpg",
      icon: "thermal"
    },
    {
      title: "Embarcaciones",
      slug: "mantenimiento",
      description: "Aislamiento mofler de un barco (tubo de escape) realizado con aislamiento 100% removible.",
      image: "/assets/stdominicana/images/mantenimiento2.jpg",
      icon: "maintenance"
    },
    {
      title: "Garantizamos soluciones de alta calidad",
      slug: "garantia",
      description: "Experiencia en aislamiento industrial. Nuestros expertos así lo garantizan.",
      image: "/assets/stdominicana/images/garantia-calidad.jpg",
      icon: "consulting"
    }
  ],

  // Features/Benefits
  features: [
    {
      title: "Experiencia Comprobada",
      description: "Más de 10 años brindando soluciones térmicas de calidad en República Dominicana.",
      icon: "faTrophy"
    },
    {
      title: "Equipo Certificado",
      description: "Profesionales capacitados y certificados en aislamiento térmico industrial.",
      icon: "faCheck"
    },
    {
      title: "Materiales de Calidad",
      description: "Garantizan la eficiencia del equipo.",
      icon: "faStar"
    },
    {
      title: "Soporte Técnico",
      description: "Atención al cliente y soporte técnico disponible.",
      icon: "faScrewdriverWrench"
    }
  ],

  // Our Services Details Section (detailed services list)
  ourServicesDetails: {
    sectionId: "our-services-details",
    title: "Nuestros Servicios",
    subtitle: "",
    items: [
      {
        title: "Instalación de insulación industrial",
        description: "Instalación de insulación industrial frio, caliente y acústica: silicato de calcio, fibra de vidrio, lana mineral (mineral Wood), uretano, foam glass y otros.",
        icon: "faTools"
      },
      {
        title: "Chaquetas de protección",
        description: "Instalamos chaquetas de PVC, Aluminio y acero inoxidable en los espesores que se usan para todo tipo de industria: 0.10 hasta 0.32; estas chaquetas podemos sujetarlas con: a) tornillos de acero inoxidable, y b) bandas de acero inoxidable.",
        icon: "faShield"
      },
      {
        title: "Aislamientos para equipos con vibración",
        description: "Instalación de aislamientos para equipos con vibración, colocando bandas de acero con springs para una mejor amortiguación.",
        icon: "faCog"
      },
      {
        title: "Insulación removible y reusable",
        description: "Para las válvulas y platillos que son de temperatura crítica y que requieren mantenimiento contínuo diseñamos, fabricamos e instalamos insulación removible y reusable tipo almohadillas (pads o blankets) los cuales son hechos con fibras cerámicas (ceramic fiber) de alta densidad, la cual puede soportar hasta 1,200 grados farenheit. Es importante describir que en la parte interior del blanket que es la que va sobre el equipo, le colocamos una maya de acero inoxidable para impedir la salida de las fibras cerámicas. En la parte exterior del blanket le colocamos tela de silicona (silicone cloth) que es completamente impermeable, la cual evita e impide el paso de aguas y sales que son corrosivos al metal, además de que la tela de silicona es resistente al fuego.",
        icon: "faFire"
      },
      {
        title: "Asesoría gratuita",
        description: "Proveemos asesoría para soluciones térmicas de manera gratuita.",
        icon: "faHandshake"
      }
    ],
    author: {
      name: "Sr. Luis Rijo",
      position: "Encargado de Operaciones",
      image: "/assets/stdominicana/images/team/luis-rijo.jpg"
    }
  },

  // Our Experience Section (from stdom.html - id="our-experience")
  // Grid layout with main title and 4 subsections
  ourExperience: {
    sectionId: "our-experience",
    subtitle: "HONESTIDAD, CUMPLIMIENTO Y PUNTUALIDAD ES LO QUE NOS CARACTERIZA",
    title: "Nuestros expertos garantizan soluciones de alta calidad",
    description: "Soluciones Térmicas cuenta con un equipo humano altamente capacitado en la instalación de Aislamientos Térmicos lo que garantiza que las maquinarias aisladas estarán protegidas de la temperatura ambiental según la necesidad y a la vez estas no obstruirán la estadía humana en el área.",
    backgroundColor: "/assets/stdominicana/images/soluciones-termicas-dominicana-motor-embarcaciones.jpg",
    items: [
      {
        title: "Variedad de opciones para satisfacer tus necesidades",
        description: "Ofrecemos una amplia gama de materiales para el aislamiento térmico industrial, incluyendo Silicato de Calcio, Fibra de Vidrio, Lana Mineral, Uretano, Foam Glas y otros.",
        icon: "faCheck"
      },
      {
        title: "Personalizamos cada proyecto para satisfacer tus requisitos específicos",
        description: "Con nuestra profesionalidad y respuesta rápida hemos personalizado todos los proyectos realizados por ser únicos en el Mercado Industrial.",
        icon: "faUserGear"
      },
      {
        title: "Comprometidos con la Excelencia y la Seguridad",
        description: "Hemos establecido una agilidad en la consecución de dichos proyectos con una calidad y seguridad insuperables.",
        icon: "faClockRotateLeft"
      },
      {
        title: "Expertos en Instalación y Servicio al Cliente",
        description: "No solo somos expertos en instalación de Aislamientos Térmicos, sino que también nos esforzamos en brindar el mejor servicio al cliente enfocados en su satisfacción desde el día de contacto, seguimiento en el proceso hasta la conclusión del servicio ofrecido.",
        icon: "faUserTie"
      }
    ]
  },

  // Our Solutions Section (from stdom.html - id="our-solutions")
  // Background image section with solution items
  ourSolutions: {
    sectionId: "our-solutions",
    backgroundImage: "/assets/stdominicana/images/pexels-photo-2327065.jpeg",
    overlay: true,
    layout: "fullwidth-background",
    content: {
      subtitle: "Nuestras Soluciones",
      title: "Somos especialistas en soluciones térmicas para el sector industrial",
      items: [
        {
          title: "Protección para equipos calientes",
          description: "Instalamos todo tipo de aislamiento térmico en tuberías, equipos y tanques para proteger contra altas temperaturas"
        },
        {
          title: "Embarcaciones mas seguras",
          description: "Soluciones especializadas para el sector marítimo garantizando seguridad y eficiencia"
        },
        {
          title: "Consultoría Especializada",
          description: "Asesoramos en la selección del mejor material para su aplicación específica"
        },
        {
          title: "Proyectos Llave en Mano",
          description: "Ejecutamos proyectos completos desde el diseño hasta la instalación final"
        }
      ]
    }
  },

  // Testimonials
  testimonials: [
    {
      name: "Carlos Rodríguez",
      company: "Industrias del Caribe S.A.",
      position: "Gerente de Operaciones",
      text: "Excelente servicio, lograron reducir nuestros costos energéticos en un 30%. Muy profesionales.",
      image: "/assets/stdominicana/images/testimonials/client-1.jpg",
      rating: 5
    },
    {
      name: "María González",
      company: "Manufacturera Dominicana",
      position: "Directora de Planta",
      text: "El equipo de Soluciones Térmicas fue muy profesional. El trabajo quedó impecable.",
      image: "/assets/stdominicana/images/testimonials/client-2.jpg",
      rating: 5
    }
  ],

  // Company in Numbers Section (from stdom.html - id="company-in-numbers")
  companyInNumbers: {
    sectionId: "company-in-numbers",
    title: "Empresas nacionales e internacionales confían en nuestros servicios y productos de calidad.",
    backgroundImage: "/assets/stdominicana/images/soluciones-termicas-dominicana-seguridad-colaboradores.jpeg",
    overlay: true,
    numbers: [
      {
        number: "15+",
        label: "Empresas satisfechas"
      },
      {
        number: "60+",
        label: "Trabajos realizados"
      },
      {
        number: "10+",
        label: "Años de experiencia"
      }
    ]
  },

  // Image Gallery Section (from stdom.html - id="image-gallery")
  imageGallery: {
    sectionId: "image-gallery",
    title: "Descubre nuestra galería de fotos",
    subtitle: "Proyectos realizados con excelencia",
    images: [
      "/assets/stdominicana/images/projects/project-1.jpg",
      "/assets/stdominicana/images/projects/project-2.jpg",
      "/assets/stdominicana/images/projects/project-3.jpg",
      "/assets/stdominicana/images/projects/project-4.jpg",
      "/assets/stdominicana/images/projects/project-5.jpg",
      "/assets/stdominicana/images/projects/project-6.jpg"
    ]
  },

  // Completed Projects - Before/After Gallery
  completedProjects: {
    sectionId: "completed-projects",
    title: "Trabajos Realizados",
    subtitle: "Transformaciones que Hablan por Sí Mismas",
    description: "Conoce algunos de nuestros proyectos más destacados de aislamiento térmico industrial. Cada trabajo demuestra nuestro compromiso con la excelencia y la calidad.",
    galleryTitle: "Galería de imágenes",
    gallerySubtitle: "Explora más trabajos realizados",
    galleryImages: [
      {
        src: "/assets/stdominicana/images/projects/gallery/trabajos-realizados-1.jpeg",
        alt: "Aislamiento de tuberías",
        caption: "Instalación de aislamiento térmico en tuberías industriales"
      },
      {
        src: "/assets/stdominicana/images/projects/gallery/trabajos-realizados-2.jpeg",
        alt: "Motor marítimo aislado",
        caption: "Aislamiento completo de motor de embarcación"
      },
      {
        src: "/assets/stdominicana/images/projects/gallery/trabajos-realizados-3.jpg",
        alt: "Tanques con aislamiento",
        caption: "Tanques de almacenamiento con protección térmica"
      },
      {
        src: "/assets/stdominicana/images/projects/gallery/trabajos-realizados-4.jpg",
        alt: "Sistema de ventilación",
        caption: "Ductos y sistema de ventilación naval"
      },
      {
        src: "/assets/stdominicana/images/projects/gallery/trabajos-realizados-5.jpeg",
        alt: "Calderas industriales",
        caption: "Aislamiento de calderas de vapor"
      },
      {
        src: "/assets/stdominicana/images/projects/gallery/trabajos-realizados-6.jpeg",
        alt: "Equipos de refrigeración",
        caption: "Sistema de refrigeración con aislamiento criogénico"
      },
      {
        src: "/assets/stdominicana/images/projects/gallery/trabajos-realizados-7.jpeg",
        alt: "Detalle de instalación",
        caption: "Detalle de acabado en aluminio"
      },
      // {
      //   src: "/assets/stdominicana/images/projects/gallery/gallery-8.jpg",
      //   alt: "Trabajo en proceso",
      //   caption: "Proceso de instalación de fibra mineral"
      // },
      // {
      //   src: "/assets/stdominicana/images/projects/gallery/gallery-9.jpg",
      //   alt: "Equipo en acción",
      //   caption: "Nuestro equipo técnico en acción"
      // },
      // {
      //   src: "/assets/stdominicana/images/projects/gallery/gallery-10.jpg",
      //   alt: "Proyecto completo",
      //   caption: "Vista general de proyecto finalizado"
      // },
      // {
      //   src: "/assets/stdominicana/images/projects/gallery/gallery-11.jpg",
      //   alt: "Aislamiento de válvulas",
      //   caption: "Protección térmica de válvulas y accesorios"
      // },
      // {
      //   src: "/assets/stdominicana/images/projects/gallery/gallery-12.jpg",
      //   alt: "Instalación naval",
      //   caption: "Trabajos especializados en embarcaciones"
      // }
    ],
    projects: [
      {
        id: 1,
        title: "Aislamiento de Motor Marítimo",
        client: "Empresa Marítima del Caribe",
        description: "Instalación completa de aislamiento térmico en motor de embarcación, mejorando la seguridad y eficiencia.",
        category: "Marítimo",
        date: "2024",
        beforeAfter: [
          {
            before: "/assets/stdominicana/images/projects/gallery/antes-trabajos-realizados-1.jpeg",
            after: "/assets/stdominicana/images/projects/gallery/despues-trabajos-realizados-1.jpeg",
            description: "Múltiple de escape de motor - Sala de máquinas"
          }
        ]
      },
      // {
      //   id: 2,
      //   title: "Aislamiento de Tuberías Industriales",
      //   client: "Industrias del Este",
      //   description: "Protección térmica de sistema de tuberías de alta temperatura con lana mineral y acabado en aluminio.",
      //   category: "Industrial",
      //   date: "2024",
      //   beforeAfter: [
      //     {
      //       before: "/assets/stdominicana/images/projects/project-2-before.jpg",
      //       after: "/assets/stdominicana/images/projects/project-2-after.jpg",
      //       description: "Sistema de tuberías de vapor"
      //     }
      //   ]
      // },
      // {
      //   id: 3,
      //   title: "Tanques de Almacenamiento",
      //   client: "Manufacturera Dominicana",
      //   description: "Aislamiento térmico de tanques de almacenamiento para mantener temperatura constante y reducir pérdidas energéticas.",
      //   category: "Industrial",
      //   date: "2023",
      //   beforeAfter: [
      //     {
      //       before: "/assets/stdominicana/images/projects/project-3-before.jpg",
      //       after: "/assets/stdominicana/images/projects/project-3-after.jpg",
      //       description: "Tanques de 5000 galones"
      //     }
      //   ]
      // },
      // {
      //   id: 4,
      //   title: "Sistema de Ventilación Naval",
      //   client: "Naviera del Caribe",
      //   description: "Aislamiento acústico y térmico de sistema de ventilación en embarcación comercial.",
      //   category: "Marítimo",
      //   date: "2023",
      //   beforeAfter: [
      //     {
      //       before: "/assets/stdominicana/images/projects/project-4-before.jpg",
      //       after: "/assets/stdominicana/images/projects/project-4-after.jpg",
      //       description: "Ductos de ventilación"
      //     }
      //   ]
      // },
      // {
      //   id: 5,
      //   title: "Calderas Industriales",
      //   client: "Procesadora Central",
      //   description: "Renovación de aislamiento térmico en calderas de vapor con materiales de última generación.",
      //   category: "Industrial",
      //   date: "2023",
      //   beforeAfter: [
      //     {
      //       before: "/assets/stdominicana/images/projects/project-5-before.jpg",
      //       after: "/assets/stdominicana/images/projects/project-5-after.jpg",
      //       description: "Calderas de vapor de 150 HP"
      //     }
      //   ]
      // },
      // {
      //   id: 6,
      //   title: "Aislamiento de Equipos de Refrigeración",
      //   client: "Frigoríficos del Norte",
      //   description: "Instalación de aislamiento criogénico para equipos de refrigeración industrial.",
      //   category: "Refrigeración",
      //   date: "2022",
      //   beforeAfter: [
      //     {
      //       before: "/assets/stdominicana/images/projects/project-6-before.jpg",
      //       after: "/assets/stdominicana/images/projects/project-6-after.jpg",
      //       description: "Sistema de refrigeración"
      //     }
      //   ]
      // }
    ]
  },

  // Testimonials Section (from original HTML - Section #6)
  testimonials: {
    sectionId: "testimonials",
    title: "Opiniones de Clientes",
    subtitle: "Lo que dicen nuestras empresas clientes",
    items: [
      {
        name: "Carlos Rodríguez",
        company: "Industrias del Caribe",
        position: "Gerente de Mantenimiento",
        text: "Excelente trabajo, muy profesionales y puntuales. Recomendados 100%",
        image: "/assets/stdominicana/images/testimonials/client-1.jpg",
        rating: 5
      },
      {
        name: "María González",
        company: "Manufacturera Dominicana",
        position: "Directora de Operaciones",
        text: "El equipo de Soluciones Térmicas superó nuestras expectativas. Trabajo de primera calidad.",
        image: "/assets/stdominicana/images/testimonials/client-2.jpg",
        rating: 5
      }
    ]
  },

  // CTA Section (from original HTML - Section #8)
  cta: {
    sectionId: "cta",
    variant: "gradient", // Blue to dark gradient
    title: "Contáctanos para recibir una cotización gratuita.",
    subtitle: "Estamos listos para ayudarte con tu proyecto de aislamiento térmico",
    button: {
      text: "Solicita Cotización",
      url: "https://api.whatsapp.com/send?phone=18098730741&text=Hola%21%20Quisiera%20m%C3%A1s%20informaci%C3%B3n%20sobre%20los%20servicios%20de%20..."
    }
  },

  // Contact Information
  contact: {
    address: "Calle Marcos del Rosario #11, Los Mina, Santo Domingo Este. República Dominicana.",
    phone: "(809) 597-9481",
    whatsapp: "(809) 873-0741",
    whatsapp2: "(829) 906-7626",
    email: "info@stdominicana.com",
    // social: {
    //   facebook: "https://facebook.com/stdominicana",
    //   instagram: "https://instagram.com/stdominicana",
    //   linkedin: "https://linkedin.com/company/stdominicana"
    // }
  },

  // SEO & Meta
  seo: {
    title: "Soluciones Térmicas Dominicana - Aislamiento Térmico Industrial",
    description: "Expertos en aislamiento térmico industrial en República Dominicana. Instalación, mantenimiento y consultoría para tu empresa.",
    keywords: "aislamiento térmico, soluciones térmicas, industrial, República Dominicana, Santo Domingo, tuberías, equipos, tanques"
  }
};

export default data;
